import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { ToastService } from '../services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast    = inject(ToastService);
  const transloco = inject(TranslocoService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // 401/403 are handled by authInterceptor (redirect to login)
      if (error.status === 401 || error.status === 403) {
        return throwError(() => error);
      }

      const message = resolveMessage(error, transloco);
      toast.error(message);
      return throwError(() => error);
    }),
  );
};

function resolveMessage(error: HttpErrorResponse, transloco: TranslocoService): string {
  if (error.status === 0) {
    return transloco.translate('common.error.network');
  }

  // Backend may return { message: '...' } or { error: '...' } or plain string
  const body = error.error;
  if (typeof body === 'string' && body.trim()) return body.trim();
  if (body?.message && typeof body.message === 'string') return body.message;
  if (body?.error   && typeof body.error   === 'string') return body.error;

  return transloco.translate('common.error.unknown');
}
